module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "carrousel"
    }
  }, [_c('slider', {
    attrs: {
      "animation": "normal",
      "width": "100%",
      "height": "300px",
      "init-index": 0,
      "auto": true,
      "interval": 6000
    }
  }, [_c('slider-item', [_c('div', {
    staticClass: "slide-background"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/carrousel/test1.png"
    }
  })]), _vm._v(" "), _c('article', [_c('p', [_vm._v(" Venez participer aux formations présentielles gratuitement ")]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "logo2",
    attrs: {
      "src": "/static/img/voir-maintenant.png"
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/events', false)
      }
    }
  })])])]), _vm._v(" "), _c('slider-item', [_c('div', {
    staticClass: "slide-background"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/carrousel/test2.png"
    }
  })]), _vm._v(" "), _c('article', [_c('p', [_vm._v("Inscrivez-vous pour avoir accès à du contenu supplémentaire.")]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "logo2",
    attrs: {
      "src": "/static/img/inscrire.png"
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/register', false)
      }
    }
  })])])]), _vm._v(" "), _c('slider-item', [_c('div', {
    staticClass: "slide-background"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/carrousel/test3.png"
    }
  })]), _vm._v(" "), _c('article', [_c('p', [_vm._v("Aidants, qui sont-ils ?")]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "logo2",
    attrs: {
      "src": "/static/img/voir-maintenant.png"
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/roles-des-aidants', true)
      }
    }
  })])])]), _vm._v(" "), _c('slider-item', [_c('div', {
    staticClass: "slide-background"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/carrousel/test4.png"
    }
  })]), _vm._v(" "), _c('article', [_c('p', [_vm._v("Comprendre le vieillissement")]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "logo2",
    attrs: {
      "src": "/static/img/voir-maintenant.png"
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/roles-des-aidants', true)
      }
    }
  })])])]), _vm._v(" "), _c('slider-item', [_c('div', {
    staticClass: "slide-background"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/carrousel/test5.png"
    }
  })]), _vm._v(" "), _c('article', [_c('p', [_vm._v("Le rôle des Aidants")]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "logo2",
    attrs: {
      "src": "/static/img/voir-maintenant.png"
    },
    on: {
      "click": function($event) {
        return _vm.navigate('/roles-des-aidants', true)
      }
    }
  })])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6282cca4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Carrousel.vue
// module id = 447
// module chunks = 1